import styled, { css } from 'styled-components';
import { Box } from '@openfin/ui-library';

export const InputContainer = styled(Box)`
  width: 100%;
  display: flex;
  margin: 10px 0;
`;

export interface InputElementProps {
  $validationError?: boolean;
}

export const SingleLineText = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  ${SingleLineText}
`;

export const InlineLabel = styled.label`
  display: inline;
  padding-left: 10px;
`;

export const defaultInputBoxCSS = css<{ $validationError?: boolean }>`
  width: 100%;
  padding: ${({ theme }) => `${theme.px.small} ${theme.px.base}`};
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme }) => theme.palette.inputBg};
  border: 1px solid
    ${(props) => (props.$validationError ? props.theme.palette.statusCritical : 'transparent')};
  color: ${({ theme }) => theme.palette.textDefault};
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  &::placeholder {
    color: ${({ theme }) => theme.palette.inputPlaceholder};
  }

  &:focus {
    border: 1px solid ${({ theme }) => theme.palette.brandPrimary};
    outline: none;
  }
`;

export const CheckboxLabelWrapper = styled.label`
  user-select: none;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  cursor: pointer;
  input {
    margin-right: 10px;
    cursor: pointer;
  }
`;
